import { createVuetify } from 'vuetify'
import colors from 'vuetify/util/colors'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { defineNuxtPlugin } from 'nuxt/app'

export default defineNuxtPlugin((nuxtApp) => {
  const vuetify = createVuetify({
    icons: {
      defaultSet: 'mdi',
      aliases,
      sets: {
        mdi,
      },
    },
    theme: {
      defaultTheme: 'light',
      themes: {
        light: {
          colors: {
            primary: '#00C0D8',
            accent: '#00FEFE',
            secondary: '#2B333B',
            info: '#00FEFE',
            warning: colors.amber.base,
            error: '#E82026',
            success: colors.green.accent3,
          },
        },
      },
    },
    display: {
      mobileBreakpoint: 'md',
      thresholds: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920,
        xxl: 2560,
      },
    },
    // enforce font inside Vuetify components
    defaults: {
      global: {
        style: {
          fontFamily: '"Open Sans", sans-serif',
        },
      },
      VBtn: {
        class: 'text-none',
      },
    },
  })

  nuxtApp.vueApp.use(vuetify)
})
